import { z } from 'zod';

export const ReputationFeedbackFormSchema = z.object({
  feedbackText: z.string().min(1, 'Required'),
});

export type ReputationFeedback = z.infer<typeof ReputationFeedbackFormSchema>;
